import React from "react"

// react-bootstrap imports
import Container from "react-bootstrap/Container"
import Col from "react-bootstrap/Col"
import Row from "react-bootstrap/Row"
import { ServiceSectionLegado } from "components/ServiceSectionLegado"

import jsonServicosTaxas from "json/ServicosTaxas.json"

import * as Links from "constants/links"

export function TaxasLegadoServicosScreen()
{
    const sections = jsonServicosTaxas

    return (
        <Container className="d-flex flex-column mb-3">
            <h4 className="text-center text-primary">Selecione o serviço para calcular sua taxa - método antigo</h4>
            <h6 className="text-center"><b>Aviso:</b> use o novo método de cálculo. Ele já está vigente desde o dia 01/04/2024. Esta página deve ser usada apenas para conferência</h6>
            <hr className="w-75 align-self-center opacity-100 text-black"/>
            <Row className="d-flex flex-wrap">
                {sections.map(sec => <Col key={sec.tipoServico}><ServiceSectionLegado data={sec} destiny={Links.CALCULAR_TAXAS_LEGADO} /></Col>)}
            </Row>
        </Container>
    )
}